module.exports = __webpack_public_path__ + "assets/img/example3.e7a38282.jpg";